(function() {
	function ViewControl()
	{
		this.EventDispatcher_constructor();

		this._last = null;
		this.lastID = "";
		this.current = null;
		this.currentID = "";
		this._views = {};
		this._layer = null;
		this.TransitionClass = cm.ViewTransition;
		this.transitionOverlay = null;
	}

	var p = cjs.extend(ViewControl, cjs.EventDispatcher);

	p.registerView = function(name, ViewClass, persistent)
	{
		this._views[name] = {
			viewClass: ViewClass,
			persistent: !!persistent,
			instance: null
		};
	};

	p.setViewLayer = function(layer)
	{
		this._layer = layer;
	};

	p.setTransitionLayer = function(layer)
	{
		this.transitionOverlay = new this.TransitionClass();
		this.transitionOverlay.build();
		layer.addChild(this.transitionOverlay);
	};

	p.getViewInstance = function(name)
	{
		return this._views[name] ? this._views[name].instance : null;
	};

	p.update = function(tick)
	{
		if (this.current) this.current.update(tick);
	};

	p.resize = function(w, h)
	{
		if (this.current) this.current.resize(w, h);
	};

	p.gotoView = function(name, opts)
	{


		console.log(opts);

		var view = this._views[name];
		if (!view)
		{
			cm.log("No View with name: " + name);
			return;
		}

		this.isTransitioning = true;

		var t;
		var hasCurrent = false;
		if (this.current)
		{
			hasCurrent = true;
			this._last = this.current;
			this.current = null;

			this._lastID = this.currentID;
			this._last.setActive(false);

			this.transitionOverlay.transitIn(this._leaveView.bind(this, name, opts || {}));

			return;
		}

		this.currentID = name;
		this.current = view.instance || new view.viewClass(opts || {});
		this.current.reset();

		this._layer.removeAllChildren();
		this._layer.addChild(this.current);

		if (!hasCurrent) {
			this.transitionOverlay.transitOut(this._enterView.bind(this));
		} else {
			this._enterView();
		}

	};

	p.hardSet = function(name, opts) {
		var view = this._views[name];
		if (!view)
		{
			cm.log("No View with name: " + name);
			return;
		}

		if (this.current)
		{
			hasCurrent = true;
			this._last = this.current;
			this.current = null;
			this._lastID = this.currentID;
			this._last.setActive(false);
			this._last.destroy();
		}

		this.currentID = name;
		this.current = view.instance || new view.viewClass(opts || {});
		this.current.reset();

		this._layer.removeAllChildren();
		this._layer.addChild(this.current);

		this._enterView();
	};

	p._leaveView = function(name, opts) {
		this._last.destroy();
		this.gotoView(name, opts);
	};

	p._enterView = function() {
		this.current.start();
		this.isTransitioning = false;
		this._last = null;
	};

	p.gotoLoaderThen = function(manifest, callback, opts)
	{

		if (this.current) {
			this._last = this.current;
			this.current = null;
			this._lastID = this.currentID;
			this._last.setActive(false);
		}

		var options = opts || {};

		this.transitionOverlay.transitIn(function(manifest, callback, opts) {
			if (this._last) {
				this._last.destroy();
				this._layer.removeAllChildren();
			}

			if (typeof callback === "string") {
				callback = this.gotoViewAfterLoader.bind(this, callback, opts);
			}

			cm.app.game.loadingScreen.animateIn();
			cm.Assets.load(manifest, callback);

		}.bind(this, manifest, callback, options));
	};

	p.gotoViewAfterLoader = function(name, opts) {
		cm.app.game.loadingScreen.animateOut().call(this.gotoView, [name, opts], this);
	};

	p.transitOut = function()
	{
		return this.transitionOverlay.transitOut();
	};

	p.transitIn = function()
	{
		return this.transitionOverlay.transitIn();
	};

	p.justHideTransition = function() {
		this.transitionOverlay.justHide();
	};

	var ViewControlClass = createjs.promote(ViewControl, "EventDispatcher");
	cm.ViewControl = new ViewControlClass();
})();